import {
  CAMPAIGN_HASH,
  CREDITS_HASH,
  STUDIO_HASH,
  type SitePage,
} from '../routes'

export interface SiteFooterProps {
  currentPage: SitePage
}

export function SiteFooter({ currentPage }: SiteFooterProps) {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__identity">
          Million Dollar Model X · Independent owner project
        </p>
        <nav className="site-footer__nav" aria-label="Project information">
          <a
            className="site-footer__link"
            href={CAMPAIGN_HASH}
            aria-current={currentPage === 'campaign' ? 'page' : undefined}
          >
            Campaign
          </a>
          <a
            className="site-footer__link"
            href={STUDIO_HASH}
            aria-current={currentPage === 'studio' ? 'page' : undefined}
          >
            Placement Studio
          </a>
          <a
            className="site-footer__link"
            href={CREDITS_HASH}
            aria-current={currentPage === 'credits' ? 'page' : undefined}
          >
            Credits
          </a>
        </nav>
      </div>
    </footer>
  )
}
